import { buttonColorType, buttonPresetType } from "../interface/Button.interface";
import { textColorType, textPresetType } from "../../../Text/interface/Text.interface";

interface textStyleInterface{
    textColor: textColorType; 
    textPreset: textPresetType;
}

const useButtonText = (
    {
        color,
        preset,
        disabled
    }:{
        color?: buttonColorType;
        preset?: buttonPresetType;
        disabled?: boolean;
    }
) => {
    const RTN: textStyleInterface = {
        textColor: "dark",
        textPreset: "button",
    }

    if(preset){
        switch(preset){
            case "normal":
                RTN.textColor = "dark";
                break;
            case "cancel":
                RTN.textColor = "dark";
                break;
            case "delete":
                RTN.textColor = "white";
                break;
            case "save":
                RTN.textColor = "white";
                break;
            case "agree":
                RTN.textColor = "white";
                break;
            case "edit":
                RTN.textColor = "white";
                break;
            case "move_page":
                RTN.textColor = "primary";
                break;
            case "detail_modal":
                RTN.textColor = "secondary";
                RTN.textPreset = "detail_modal";
                break;
            case "detail_view":
                RTN.textColor = "secondary";
                RTN.textPreset = "detail_modal";
                break;
            case "trashcan_icon_btn":
                RTN.textColor = "red_gray";
                RTN.textPreset = "detail_modal";
                break;
            default :
        }
    }

    if(color){
        switch(color){
            case "primary":
                RTN.textColor = "white";
                break;
            case "gray":
                RTN.textColor = "dark";
                break;
            default :
        }
    }

    if(disabled){
        RTN.textColor = "gray3";
    }

    return(RTN)
}

export default useButtonText;